var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRwCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 31",
    fill: "none",
    preserveAspectRatio: "xMidYMid meet",
    "aria-hidden": "true",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1226_1622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4.75C4 3.58515 4 3.00272 4.1903 2.54329C4.44404 1.93072 4.93072 1.44404 5.54329 1.1903C6.00272 1 6.58515 1 7.75 1H20.25C21.4149 1 21.9973 1 22.4567 1.1903C23.0693 1.44404 23.556 1.93072 23.8097 2.54329C24 3.00272 24 3.58515 24 4.75M10.25 21H17.75M14 1V21",
    stroke: "url(#paint0_linear_1226_1622)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1226_1622",
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 30.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1226_1622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1226_1622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1226_1622",
    x1: 23.3747,
    y1: 5.37446,
    x2: 12.1244,
    y2: 12.2491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8B3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwCopy);
export default __webpack_public_path__ + "static/media/RWCopy.f6a9f2df13e8c047f2c2074df91209c8.svg";
export { ForwardRef as ReactComponent };